import FormSubmitter from '@/api/formSubmitter'

export default {
  props: {
    bookingId: {
      type: [Number, String],
      required: true
    },
    token: {
      type: String,
      required: false
    },
    isUnlogged: {
      type: Boolean,
      default: false
    },
    anonymous: {
      type: Boolean
    }
  },

  methods: {
    confirm () {
      let submitter = new FormSubmitter(this.submitterInfos.type, this.submitterInfos.values)

      submitter.submitRequest(this.submitterInfos.values, this.anonymous ? this.token : this.bookingId)
        .then(response => {
          if (response.data.success) {
            this.dealSuccess()
          } else {
            this.dealFailure(response.data.errors)
          }
        })
    },

    dealSuccess () {
      this.$emit('ok', {
        success: true,
        message: this.successMessage
      })

      if (this.closeAfterServerResponse) {
        this.$bvModal.hide(this.id)
        if (typeof this.reset !== 'undefined') {
          this.reset()
        }
      }
    },

    dealFailure (errors) {
      if (typeof this.setErrorMessage !== 'undefined') {
        this.setErrorMessage(errors[0])
      }
    },

    cancel () {
      for (let i in this.submitterInfos.values) {
        if (this.submitterInfos.values.hasOwnProperty(i)) {
          this.submitterInfos.values[i] = null
        }
      }
    }
  },

  computed: {
    cancellationReasons () {
      return this.$store.getters['data/bookingCancellationReasons']
    }
  }
}
